<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
    <div class="dish-container">
      <div class="title-bar">
        <div class="back-btn" @click="back">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <span class="title-bar-text">营养分析 ● 美食红绿灯</span>
        <div class="fullscreen-btn" @click="handleFullScreen">
          <div v-if="fullscreen">
            <i class="el-icon-aim"></i>
            <span> 退出全屏</span>
          </div>
          <div v-else>
            <i class="el-icon-full-screen"></i>
            <span> 全屏</span>
          </div>
        </div>
      </div>
      <div class="store-section">
        <!-- <div class="store-title"><i class="el-icon-s-shop store-title-icon"></i>餐厅信息</div> -->
        <div class="store-card">
          <div class="store-item">
            <span class="store-value">{{ storeInfo.name }}</span>
            <span class="store-label">门店名称</span>
          </div>
          <div class="store-item">
            <span class="store-value address-value">{{ storeInfo.address }}</span>
            <span class="store-label">地址</span>
          </div>
          <div class="store-item store-contact">
            <span class="store-value contact-value">
              <span class="contact-name">{{ storeInfo.manager }}</span>
              <span class="contact-phone">{{ storeInfo.phone }}</span>
            </span>
            <span class="store-label">负责人 / 电话</span>
          </div>
        </div>
      </div>

      <div class="dish-layout">
        <div class="layout-left"> 
          <h1 class="dish-name">{{ dishInfo.name }}</h1>

          <div class="image-wrapper">
            <img :src="dishInfo.image" :alt="dishInfo.name" @error="handleImageError" />
          </div>

          <div class="info-merged" v-if="showPrice || showIngredients || showAllergens">
            <div class="merged-left" v-if="showPrice">
              <div class="section-label">
                <img src="../assets/image/price.png" style="width: 25px;">
                <span>今日菜价</span>
              </div>
              <div class="price-value">
                <span class="currency">¥</span>
                <span class="amount">{{ dishInfo.price.toFixed(1) }}</span>
                <span class="unit">元/份</span>
              </div>
            </div>
            <div class="merged-divider" v-if="showPrice && showIngredients"></div>
            <div class="merged-center" v-if="showIngredients">
              <div class="section-label">
                <img src="../assets/image/yuanliao.png" style="width: 20px;">
                <span>菜品原料</span>
              </div>
              <div class="tags-container">
                <span 
                  v-for="(ingredient, index) in dishInfo.ingredients" 
                  :key="index"
                  class="tag"
                >
                  {{ ingredient }}
                </span>
              </div>
            </div>
            <div class="merged-divider" v-if="showIngredients && showAllergens"></div>
            <div class="merged-right" v-if="showAllergens">
              <div class="section-label">                
                <img src="../assets/image/guoming.png" style="width: 20px;">
                <span>过敏源</span>
              </div>
              <div class="tags-container">
                <span 
                  v-for="(allergen, index) in dishInfo.allergens" 
                  :key="index"
                  class="tag tag-warn"
                >
                  {{ allergen }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="layout-right">
          <div class="card-box" style="margin-bottom: 20px;">
            <div class="card-header">
              <div class="section-label">                              
                <img src="../assets/image/yingyang.png" style="width: 20px;">
                <span class="bold-text">营养标签可视化卡</span>
              </div>
              <div class="legend">
                <span class="legend-dot" style="background:#2c833c"></span>
                <span class="text-green">正常吃</span>
                <span class="split">|</span>
                <span class="legend-dot" style="background:#d2b13c"></span>
                <span class="text-yellow">限制吃</span>
                <span class="split">|</span>
                <span class="legend-dot" style="background:#a01d24"></span>
                <span class="text-red">避免吃</span>
              </div>
            </div>

            <div class="indicators-bar">
              <div v-for="(tag, index) in dishInfo.healthTags" :key="index" class="indicator-item">
                <span class="indicator-label">{{ tag.label }}</span>
                <span 
                  class="dot"
                  :class="{
                    'dot-green': tag.status === 'normal',
                    'dot-yellow': tag.status === 'limit',
                    'dot-red': tag.status === 'avoid'
                  }"
                ></span>
              </div>
            </div>
          </div>

          <div class="card-box flex-grow">
            <div class="card-header align-end">
              <div class="section-label">                          
                <img src="../assets/image/chenfen.png" style="width: 20px;">
                <span class="bold-text">营养成分表</span>
              </div>
              <span class="tip-text">1毫克(mg)钠相当于2.5毫克(mg)食盐</span>
            </div>

            <div v-if="renderMode === 'data'" class="table-container">
              <div class="table-header">
                <div class="col-left">项目</div>
                <div class="col-center">每份</div>
                <div class="col-right">NRV%</div>
              </div>
              <div class="table-body">
                <div 
                  v-for="(item, index) in dishInfo.nutritionTable" 
                  :key="index" 
                  class="table-row"
                >
                  <div class="col-left">{{ item.project }}</div>
                  <div class="col-center">{{ item.perServing }}</div>
                  <div class="col-right font-mono">{{ item.nrv }}</div>
                </div>
              </div>
            </div>

            <div v-else-if="renderMode === 'image'" class="image-container">
              <img 
                :src="dishInfo.nutritionImg" 
                alt="营养成分表图片" 
                class="nutrition-image"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="desc-poster-section">
        <div class="poster-inner-layout">
          <div class="poster-text-content">
            <div class="poster-title-area">
              <div class="poster-main-title">美食红绿灯说明</div>
              <div class="poster-title-line"></div>
            </div>

            <div class="instruction-list">
              <div class="instruction-item">
                <span class="number-badge">1</span>
                <p class="instruction-text">
                  以“绿、黄、红”三色食品营养标识，面向<strong class="highlight">“肥胖、高血糖、高血脂、高尿酸、高血压”</strong>等“1+4慢病”患者及高危人群提供膳食指导
                </p>
              </div>

              <div class="instruction-item">
                <span class="number-badge">2</span>
                <div class="instruction-sub-list">
                  <div class="sub-list-row">
                    <span class="bullet-title text-green">正常吃：</span>
                    <span class="bullet-desc">代表无需担心对应慢病风险，但应杜绝暴饮暴食；</span>
                  </div>
                  <div class="sub-list-row">
                    <span class="bullet-title text-yellow">限制吃：</span>
                    <span class="bullet-desc">代表对应慢病患者及其高危人群应少吃；</span>
                  </div>
                  <div class="sub-list-row">
                    <span class="bullet-title text-red">避免吃：</span>
                    <span class="bullet-desc">代表对应慢病患者及其高危人群应不吃</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-scale-screen>
</template>

<script>import {
  getDishRedGreen
} from "../api/api";
export default {
  name: 'DishDetail',
  data() {
    return {
      fullscreen: false,
      renderMode: 'data',
      dishList: [],
      currentIndex: 0,
      timer: null,
      dishInfo: {
        name: '',
        image: '',
        price: null,
        ingredients: [],
        allergens: [],
        healthTags: [],
        nutritionTable: [],
        nutritionImg: ''
      },
      storeInfo: {
        name: '',
        address: '',
        manager: '',
        phone: ''
      }
    }
  },
  computed: {
    showPrice() {
      var p = this.dishInfo.price
      return p != null && p !== '' && p !== '无' && Number(p) > 0
    },
    showIngredients() {
      return this.dishInfo.ingredients.length > 0
    },
    showAllergens() {
      return this.dishInfo.allergens.length > 0
    }
  },
  mounted() {
    this.getStoreInfo()
    this.getDishRedGreen()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 从本地读取门店信息
    getStoreInfo() {
      this.storeInfo = {
        name: localStorage.getItem('shop_name') || '',
        address: localStorage.getItem('shop_address') || '',
        manager: localStorage.getItem('shop_owner') || '',
        phone: localStorage.getItem('shop_phone') || ''
      }
    },
    // 标签文字 → status 映射
    tagToStatus(tagText) {
      const map = {
        '正常吃': 'normal',
        '限制吃': 'limit',
        '避免吃': 'avoid'
      }
      return map[tagText] || 'normal'
    },
    // 将后端单条数据转换为前端 dishInfo 结构
    transformItem(item) {
      var ingredients = item.baseinfo
        ? item.baseinfo.split('|').filter(function(v) { return v !== '' })
        : []
      var allergens = item.allergy && item.allergy !== '无'
        ? item.allergy.split('|').filter(function(v) { return v !== '' })
        : []
      var self = this
      var healthTags = [
        { label: '肥胖人群', status: self.tagToStatus(item.fat_tag) },
        { label: '高血糖', status: self.tagToStatus(item.blood_sugar_tag) },
        { label: '高血脂', status: self.tagToStatus(item.blood_lipid_tag) },
        { label: '高尿酸', status: self.tagToStatus(item.uric_acid_tag) },
        { label: '高血压', status: self.tagToStatus(item.blood_pressure_tag) }
      ]
      var nutritionTable = [
        { project: '能量', perServing: item.calories_per100 + 'kal', nrv: item.calories_nrv + '%' },
        { project: '蛋白质', perServing: item.protein_g + 'g', nrv: item.protein_nrv + '%' },
        { project: '脂肪', perServing: item.fat_g + 'g', nrv: item.fat_nrv + '%' },
        { project: '碳水化合物', perServing: item.carb_g + 'g', nrv: item.carb_nrv + '%' },
        { project: '糖', perServing: item.sugar_g + 'g', nrv: item.sugar_nrv + '%' },
        { project: '钠/食盐', perServing: item.sodium_mg + 'mg/' + item.salt_g + 'g', nrv: item.salt_nrv + '%' }
      ]
      return {
        name: item.name,
        image: item.food_images,
        price: item.price != null && item.price !== '' && item.price !== '无' ? Number(item.price) : null,
        ingredients: ingredients,
        allergens: allergens,
        healthTags: healthTags,
        nutritionTable: nutritionTable,
        nutritionImg: item.food_images
      }
    },
    // 获取营养分析数据
    async getDishRedGreen() {
      try {
        var res = await getDishRedGreen()
        console.log('getDishRedGreen 返回:', res)
        // 兼容不同的返回结构：res.data.data / res.data / res
        var list = (res.data && res.data.data) || res.data || res
        // 如果 list 没有 length，说明不是数组，尝试取值
        if (!Array.isArray(list)) {
          list = list && list.list ? list.list : []
        }
        if (!list || list.length === 0) {
          console.warn('getDishRedGreen: 数据为空')
          return
        }
        this.dishList = list
        this.currentIndex = 0
        this.dishInfo = this.transformItem(list[0])
        this.startCarousel()
      } catch (err) {
        console.error('获取菜品数据失败:', err)
      }
    },
    // 启动轮播
    startCarousel() {
      var self = this
      if (self.timer) {
        clearInterval(self.timer)
      }
      self.timer = setInterval(function() {
        self.nextDish()
      }, 10000)
    },
    // 切换到下一个菜品
    nextDish() {
      if (this.dishList.length <= 1) return
      this.currentIndex = (this.currentIndex + 1) % this.dishList.length
      this.dishInfo = this.transformItem(this.dishList[this.currentIndex])
    },
    handleFullScreen() {
      const element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    handleImageError(e) {
      e.target.src = 'https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260717/e6d19ad5f05b4efa00da0dc2b473bd52.png'
    },
    back() {
      window.history.back()
    }
  }
}
</script>

<style scoped>
/* ============ 基础容器 ============ */
.dish-container {
  width: 1920px;
  height: 1080px;
  margin: 0;
  padding: 18px 80px 20px 80px;
  background: #F5FAF1;
  position: relative;
  overflow: hidden;
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #333;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.dish-container * {
  box-sizing: border-box;
}

/* ============ 标题栏 ============ */
.title-bar {
  position: relative;
  z-index: 1;
  background: #3C845E;
  border-radius: 18px;
  padding: 16px 60px;
  margin-bottom: 10px;
  text-align: center;
  color: #fff;
  box-shadow: 0 4px 20px rgba(60, 132, 94, 0.25);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-btn {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.2s;
}

.back-btn {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.back-btn:hover,
.fullscreen-btn:hover {
  opacity: 1;
}

.fullscreen-btn span {
  font-size: 20px;
}

.title-bar-text {
  display: block;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 6px;
}

.dish-name {
  font-size: 32px;
  font-weight: 800;
  color: #1e3320;
  margin: 10px 0;
  letter-spacing: 3px;
  padding-left: 16px;
  border-left: 5px solid #3C845E;
  line-height: 1.1;
}

/* ============ 栅格布局 ============ */
.dish-layout {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 24px;
  flex: 1 1 0%;
  margin-bottom: 8px;
  margin-top: 20px;
}

.layout-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 11px;
  min-width: 0;
}

.layout-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ============ 左侧：图片卡片 ============ */
.image-wrapper {
  width: 100%;
  max-height: 400px;
  text-align: center;
  border-radius: 45px;
  overflow: hidden;
  position: relative;
  flex: 1 1 auto;
}

.image-wrapper img {
  width: 580px;
  height: 400px;
  border-radius: 25px;
  object-fit: cover;
}

/* ============ 门店信息卡片 ============ */
.store-section {
  margin-bottom: 16px;
}

.store-title {
  font-size: 20px;
  font-weight: 700;
  color: #3C845E;
  margin-bottom: 14px;
  padding-left: 4px;
  position: relative;
  display: flex;
  align-items: center;
}

.store-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 20px;
  background: #3C845E;
  border-radius: 2px;
  margin-right: 10px;
}

.store-title-icon {
  font-size: 22px;
  margin-right: 8px;
  margin: 10px 0;
  color: #3C845E;
}

.store-card {
  background: #fff;
  border: 1px solid #e2f0d2;
  border-radius: 16px;
  padding: 16px 24px;
  box-shadow: 0 2px 16px rgba(110, 185, 43, 0.06);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  flex-shrink: 0;
}

.store-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 16px;
  position: relative;
  min-width: 0;
}

.store-item:nth-child(1) {
  flex: 1.2;
  max-width: 250px;
}

.store-item:nth-child(2) {
  flex: 2.5;
}

.store-contact {
  flex: 1.3;
}

.store-item::after {
  content: '';
  position: absolute;
  right: 0;
  top: 10px;
  bottom: 10px;
  width: 1px;
  background: #e8eee0;
}

.store-item:last-child::after {
  display: none;
}

.store-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
  letter-spacing: 1.5px;
}

.store-value {
  font-size: 20px;
  font-weight: 700;
  color: #3d7218;
  text-align: center;
  line-height: 1.4;
  word-break: break-all;
}

.address-value {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-value {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.contact-name {
  font-size: 20px;
}

.contact-phone {
  font-size: 20px;
  font-weight: 600;
  color: #558732;
}

/* ============ 合并卡片：价格 + 原料 ============ */
.info-merged {
  background: #fff;
  border-radius: 16px;
  padding: 26px 24px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.04);
  display: flex;
  gap: 24px;
  flex-shrink: 0;
}

.merged-left {
  flex-shrink: 0;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.merged-divider {
  width: 1px;
  align-self: stretch;
  background: #f0f0ed;
}

.merged-center {
  flex: 1;
  min-width: 0;
}

.merged-right {
  flex: 0 0 auto;
  min-width: 250px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #888;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.icon {
  font-size: 18px;
}

.price-value {
  display: flex;
  align-items: baseline;
}

.price-value .currency {
  font-size: 40px;
  color: #666;
  margin-right: 5px;
}

.price-value .amount {
  font-size: 44px;
  line-height: 1;
  color: #666;
}

.price-value .unit {
  color: #bbb;
  font-size: 16px;
  margin-left: 2px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  padding: 8px 16px;
  background: #f7f8f5;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 600;
  color: #5a6b4b;
}

.tag-warn {
  background: #fff8f0;
  color: #b86e30;
}

/* ============ 右侧卡片 ============ */
.card-box {
  background: #fff;
  border-radius: 16px;
  padding: 16px 24px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.04);
}

.flex-grow {
  /* flex-grow: 1; */
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header.align-end {
  align-items: flex-end;
}

.card-header .section-label {
  margin-bottom: 0;
}

.bold-text {
  font-weight: 700;
  font-size: 20px;
  color: #2e3b1e;
}

.legend {
  font-size: 18px;
  color: #bbb;
  display: flex;
  align-items: center;
}

.legend-dot {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 6px;
}

.legend .split {
  margin: 0 6px;
  color: #e0e0de;
}

.text-green { color: #2c833c; font-weight: 600; }
.text-yellow { color: #d2b13c; font-weight: 600; }
.text-red { color: #a01d24; font-weight: 600; }

.indicators-bar {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  background: #fafbf8;
  padding: 12px 12px;
  border-radius: 12px;
}

.indicator-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.indicator-label {
  font-size: 20px;
  font-weight: 600;
  color: #666;
}

.dot {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 1.5px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.dot-green { background-color: #2c833c; }
.dot-yellow { background-color: #d2b13c; }
.dot-red { background-color: #a01d24; }

/* 营养成分表 */
.tip-text {
  font-size: 15px;
  color: #bbb;
}

.table-container {
  font-size: 18px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr;
  padding: 10px 14px;
  color: #999;
  font-size: 18px;
  font-weight: 600;
  background: #fafbf8;
  border-radius: 8px;
  margin-bottom: 2px;
}

.table-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr;
  padding: 11px 14px;
  align-items: center;
  color: #555;
  border-bottom: 1px solid #f5f5f2;
}

.table-row:last-child {
  border-bottom: none;
}

.col-left { text-align: left; }
.col-center { text-align: center; }
.col-right { text-align: right; }

.font-weight-500 {
  font-weight: 700;
  color: #2e3b1e;
}

.font-mono {
  font-family: monospace;
  color: #438f47;
  font-weight: 600;
}

/* ============ 方案二：图片框 ============ */
.image-container {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
}

.nutrition-image {
  max-width: 100%;
  max-height: 380px;
  object-fit: contain;
  border-radius: 10px;
}

/* ============ 高保真：美食红绿灯说明海报样式（已被压缩缩减） ============ */
.desc-poster-section {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border: 4px solid #368e59; /* 精准边框粗细微调至 4px */
  border-radius: 16px;
  padding: 14px 28px 12px 28px;
  flex-shrink: 0;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.06);
}

.poster-inner-layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

/* 左侧文字排版 */
.poster-text-content {
  flex: 1;
  padding-right: 30px;
}

.poster-title-area {
  margin-bottom: 4px; /* 减小底边距 */
}

.poster-main-title {
  font-size: 20px; /* 调小字体 */
  font-weight: 800;
  color: #1e3c28;
  letter-spacing: 2px;
}

.poster-title-line {
  width: 100px; /* 调短装饰线 */
  height: 3px;
  background: #368e59;
  margin-top: 4px;
  border-radius: 2px;
}

/* 说明条目排版 */
.instruction-list {
  display: flex;
  flex-direction: column;
  gap: 4px; /* 紧凑布局 */
}

.instruction-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
}

.number-badge {
  flex-shrink: 0;
  width: 20px; /* 缩减序号尺寸 */
  height: 20px;
  background: #368e59;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.instruction-text {
  margin: 0;
  font-size: 18px; /* 精简字体尺寸至 14px */
  color: #333333;
  line-height: 1.5;
}

.highlight {
  color: #c0392b;
  font-weight: 700;
}

/* 子段落排版 (正常/限制/避免) */
.instruction-sub-list {
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
}

.sub-list-row {
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 1.3;
}

.bullet-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
}

.bullet-title {
  font-weight: 700;
  /* margin-right: 4px; */
  white-space: nowrap;
}

.bullet-desc {
  color: #555555;
}
</style>